import React from 'react';
import {Typography} from '@material-ui/core';
import classnames from 'classnames';

import styles from './SelectRoleDialog.scss';
import Card from 'components/controls/Card';
import Dialog from 'components/controls/dialogs/Dialog';
import CustomGrid from 'components/controls/grid/CustomGrid';
import DoctorIcon from 'components/controls/icons/DoctorIcon';
import PatientIcon from 'components/controls/icons/PatientIcon';
import CustomBox from 'components/controls/grid/CustomBox';
import SimpleButton from 'components/controls/buttons/SimpleButton';
import ButtonLink from 'components/controls/ButtonLink';

export default function SelectRoleDialog({
    onNext,
    onClose,
    onLoginLinkClick,
}) {
    return (
        <Dialog
            title={loc('sign-up')}
            onClose={onClose}
        >
            <CustomGrid
                container
                spacing="m"
            >
                <CustomGrid
                    item
                >
                    <Card
                        classes={{
                            root: styles.card,
                        }}
                    >
                        <SimpleButton
                            onClick={() => onNext('patient')}
                        >
                            <CustomBox
                                py="s"
                                px="xxl-2"
                            >
                                <PatientIcon className={styles.icon} />
                                <Typography
                                    variant="h4"
                                >
                                    {loc('i-am-patient')}
                                </Typography>
                            </CustomBox>
                        </SimpleButton>
                    </Card>
                </CustomGrid>
                <CustomGrid
                    item
                >
                    <Card
                        classes={{
                            root: classnames(styles.card, styles.doctorCard),
                        }}
                    >
                        <SimpleButton
                            onClick={() => onNext('doctor')}
                        >
                            <CustomBox
                                py="s"
                                px="xxl-2"
                            >
                                <DoctorIcon className={styles.icon} />
                                <Typography
                                    variant="h4"
                                >
                                    {loc('i-am-doctor')}
                                </Typography>
                            </CustomBox>
                        </SimpleButton>
                    </Card>
                </CustomGrid>
            </CustomGrid>
            <div className={styles.formNote}>
                {loc('already-account')}
                <ButtonLink label={loc('login-label')}
                    onClick={onLoginLinkClick}
                    className={styles.loginLink}
                />
            </div>
        </Dialog>
    );
}



// WEBPACK FOOTER //
// ./src/components/Auth/Register/SelectRoleDialog.jsx